// This file is auto-generated by ./bin/rails stimulus:manifest:update
// Run that command whenever you add a new controller or create them with
// ./bin/rails generate stimulus controllerName

import { application } from "./application"

import HelloController from "./hello_controller"
application.register("hello", HelloController)

import CalendarController from "./calendar_controller"
application.register("calendar", CalendarController)

import DropzoneController from "./dropzone_controller"
application.register("dropzone", DropzoneController)

import ChatDropzoneController from "./chat_dropzone_controller"
application.register("chat-dropzone", ChatDropzoneController)

import FormSubmitController from "./form_submit_controller"
application.register("form-submit", FormSubmitController)

import DoubleClickEdit from "./double_click_edit"
application.register("double-click-edit", DoubleClickEdit)

import InlineEditController from "./inline_edit_controller.js"
application.register("inline-edit", InlineEditController)

import CompletedTasksController from "./completed_tasks_controller.js"
application.register("completed-tasks", CompletedTasksController)

import GroupDragController from "./inventory/group_drag_controller"
application.register("group-drag", GroupDragController)

import CategoryDragController from "./inventory/category_drag_controller"
application.register("category-drag", CategoryDragController)

import RootDragController from "./inventory/root_drag_controller"
application.register("root-drag", RootDragController)

import AttributeGroupSelectController from "./inventory/attribute_group_select_controller"
application.register("attribute-group-select", AttributeGroupSelectController)

import PackSizeLabelController from "./inventory/pack_size_label_controller"
application.register("pack-size-label", PackSizeLabelController)

import CollapsibleController from "./collapsible_controller.js"
application.register("collapsible", CollapsibleController)

import TurboModalController from "./turbo_modal_controller.js"
application.register("turbo-modal", TurboModalController)

import DropdownController from "./dropdown_controller.js"
application.register("dropdown2", DropdownController)

import PopperController from "./popper_controller.js"
application.register("popper", PopperController)

import PriceController from "./price/price_controller.js"
application.register("price", PriceController)

import DeletePromptController from "./delete_prompt_controller.js"
application.register("delete-prompt", DeletePromptController)

import SubmittingController from "./submiting_controller.js"
application.register("submitting", SubmittingController)

import SlimSelectController  from "./slimselect_controller.js"
application.register("slimselect", SlimSelectController)


// ADDING INVENTORY ITEMS & RECIPES TO PARTS
import InventoryItemToPartDragdropController from "./part/inventory_item_to_part_dragdrop_controller"
application.register("inventory-item-part-dragdrop", InventoryItemToPartDragdropController)

import PartOptionContainerController from "./part/part_inventory_item_container_controller"
application.register("part-inventory-item-container", PartOptionContainerController)

import RecipeToPartDragdropController from "./part/recipe_to_part_dragdrop_controller"
application.register("recipe-part-dragdrop", RecipeToPartDragdropController)

import EstimateVisibilityController from "./estimate_visibility_controller"
application.register("estimate-visibility", EstimateVisibilityController)


// ADDING INVENTORY ITEMS TO INGREDIENTS
import InventoryItemToIngredientDragdropController from "./ingredient/inventory_item_to_ingredient_dragdrop_controller"
application.register("inventory-item-ingredient-dragdrop", InventoryItemToIngredientDragdropController)

import IngredientInventoryItemContainer from "./ingredient/ingredient_inventory_item_container_controller"
application.register("ingredient-inventory-item-container", IngredientInventoryItemContainer)


// ADDING INGREDIENTS TO RECIPES
import IngredientToRecipeDragdropController from "./recipe/ingredient_to_recipe_drag_controller"
application.register("ingredient-recipe-dragdrop", IngredientToRecipeDragdropController)

import RecipeIngredientContainerController from "./recipe/recipe_ingredient_container_controller"
application.register("recipe-ingredient-container", RecipeIngredientContainerController)


// ADDING PARTS TO TEMPLATE ROOMS
import PartToRoomDragdropController from "./template_room/part_to_room_dragdrop_controller"
application.register("part-room-dragdrop", PartToRoomDragdropController)

import RoomPartContainerController from "./template_room/room_part_container_controller"
application.register("template-room-part-container", RoomPartContainerController)



// ADDING TEMPLATE ROOMS TO TEMPLATE PROJECTS
import TemplateProjectDragdropController from "./template_project/template_project_template_room_dragdrop_controller"
application.register("template-room-template-project-dragdrop", TemplateProjectDragdropController)

import TemplateProjectTemplateRoomContainerController from "./template_project/template_project_template_room_container_controller"
application.register("template-project-template-room-container", TemplateProjectTemplateRoomContainerController)






import SelfAssessmentDocumentController from "./self_assessment_document_controller.js"
application.register("self-assessment-document", SelfAssessmentDocumentController)

import HideController from "./bookings/hide_controller.js"
application.register("hide", HideController)

import SelectShowController from "./select_show_controller.js"
application.register("select-show", SelectShowController)

import BookingCalendarController from "./bookings/bookings_calendar_controller"
application.register("bookings-calendar", BookingCalendarController)

import opp_bookings_controller from "./opp_bookings_controller";
application.register("opp-booking", opp_bookings_controller)

import PreventNavigationController from "./prevent_nav_controller.js"
application.register("prevent-nav", PreventNavigationController)

import ElementSeenController from "./message_read_controller.js"
application.register("message-read", ElementSeenController)

import DragdropListController from "./dragdrop_list_controller.js"
application.register("dragdrop-list", DragdropListController)

import ScrollToController  from "./scroll_to_controller.js"
application.register("scroll-to", ScrollToController)

import ChecklistFormController  from "./checklist_form_controller.js"
application.register("checklist-form", ChecklistFormController)

import ChecklistController  from "./checklist_controller.js"
application.register("checklist", ChecklistController)

import ChecklistTaskFormController  from "./checklist_task_form_controller.js"
application.register("checklist-task-form", ChecklistTaskFormController)

import ChecklistTaskController  from "./checklist_task_controller.js"
application.register("checklist-task", ChecklistTaskController)

import HideDestroyController  from "./hide_destroy_controller.js"
application.register("hide-destroy", HideDestroyController)

import GanttController from "./gantt_controller.js"
application.register("gantt", GanttController)

import TimeframeController from "./timeframe_controller.js"
application.register("timeframe", TimeframeController)

import TakeoffController  from "./takeoff_controller"
application.register("takeoff", TakeoffController)

import TakeoffCollapsibleController  from "./takeoff_collapsible_controller"
application.register("takeoff-collapsible", TakeoffCollapsibleController)

import ClipboardController  from "./clipboard_controller"
application.register("clipboard", ClipboardController)

import FilterController  from "./filter_controller"
application.register("filter", FilterController)

import PageReloadController  from "./page_reload_controller"
application.register("page-reload", PageReloadController)

import QuicklinkController  from "./quicklink_controller"
application.register("quicklink", QuicklinkController)

import SortableController  from "./sortable_controller"
application.register("sortable", SortableController)

import TrixAddonsController  from "./Trix/trix_addons_controller"
application.register("trix-addons", TrixAddonsController)

// Import and register all TailwindCSS Components or just the ones you need
import { Dropdown, Modal, Tabs, Popover, Slideover } from "tailwindcss-stimulus-components"
application.register('dropdown', Dropdown)
application.register('modal', Modal)
application.register('tabs', Tabs)
application.register('popover', Popover)
application.register('slideover', Slideover)

import ToggleController  from "./toggle_controller"
application.register("toggle", ToggleController)

import TogglingController  from "./toggling_controller"
application.register("toggling", TogglingController)

import CheckboxController  from "./checkbox_controller"
application.register("checkbox", CheckboxController)

import MoveDateModalController  from "./move_date_modal_controller"
application.register("move-date-modal", MoveDateModalController)

import HighlightController from "./highlight_controller"
application.register("highlight", HighlightController)

import SelectionModeController from "./selection_mode_controller"
application.register("selection-mode", SelectionModeController)

import SelectionAdvanceController from "./selection_advance_controller"
application.register("selection-advance", SelectionAdvanceController)

import TagifyController from "./tagify_controller"
application.register("tagify", TagifyController)

import SendValuesController from "./send_values_controller"
application.register("send-values", SendValuesController)

import PurchaseOrderController from "./purchase_orders_controller"
application.register("purchase-order", PurchaseOrderController)

import ImagePreviewController from "./image_preview_controller"
application.register("image-preview", ImagePreviewController)

import EstimateFilterController from "./estimate_filter_controller"
application.register("estimate-filter", EstimateFilterController)

import ExpandAllController from "./expand_all_controller"
application.register("expand-all", ExpandAllController)

import RowOpenController from "./row_open_controller"
application.register("row-open", RowOpenController)

import StaffNoteController from "./staff_note_controller"
application.register("staff-note", StaffNoteController)

import AutoDismissController from "./auto_dismiss_controller"
application.register("auto-dismiss", AutoDismissController)

import LeadQuestionFormController from "./lead_question_form_controller"
application.register("lead-question-form", LeadQuestionFormController)
